const VERSION = '2.0.15p'
export default VERSION
